const invoke_ = require('lodash/invoke')

function getErrorStacktraceFirstLine(err) {
  const printedError = err.stack.toString()
  return printedError.substring(printedError.indexOf('https://')).split('\n')[0]
}

const isAppInFirstLineInStacktrace = appName => err =>
  getErrorStacktraceFirstLine(err).includes(appName)

module.exports.isAppInvolvedWithError = appName => err =>
  err.stack && err.stack.toString().includes(appName)

module.exports.addUnhandledRejectionListener = (workerGlobalScope, callback) =>
  invoke_(workerGlobalScope, 'addEventListener', 'unhandledrejection', callback)

module.exports.extendConsoleError = (workerGlobalScope, callback) => {
  const console = workerGlobalScope.console
  const originalConsoleError = console.error.bind(console)
  console.error = (...args) => {
    try {
      callback(...args)
    } catch (e) {
      originalConsoleError(e)
    }
    originalConsoleError(...args)
  }
}

module.exports.shouldReportException = (error, ...functions) =>
  functions.reduce((res, func) => res && func(error), true)

module.exports.reportException = (error, appName, Raven, ravenOptions = {}) => {
  ravenOptions.tags = Object.assign(ravenOptions.tags || {}, {
    'errorBoundaries.isInFirstLine': isAppInFirstLineInStacktrace(appName)(
      error
    )
  })

  Raven.captureException(error, ravenOptions)
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/raven/supplementaryErrorHandlers.js